import {
  Grid,
  Button,
  TextField,
  Box,
  Stepper,
  Step,
  StepLabel,
  CircularProgress,
  Backdrop,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { RootState, RootDispatch } from "../../model";
import { useRematch } from "../../utils/useRematch";
import RolePlusSVG from "./components/RolePlusSVG";
import {
  PetsTokenList,
  RoleTokenList,
  LootTokenList,
} from "../../model/rolePlus";
import "./index.less";

const mapState = (state: RootState) => ({
  ...state.main,
  ...state.pets,
  ...state.rolePlus,
  loading: state.loading,
});

const mapDispatch = (dispatch: RootDispatch) => ({
  ...dispatch.pets,
  ...dispatch.rolePlus,
});

const steps = ["Role", "Loot", "Pets", "Custom Background"];

export default function RolePlus() {
  const [
    {
      RoleContract,
      PetsContract,
      LootContract,
      MlootContract,
      userInfo,
      PetsTokenList,
      RoleTokenList,
      LootTokenList,
      loading,
    },
    { getPetsURI, getRolesURI, getLootsURI, getMlootsURI, claimRolePlus },
  ] = useRematch(mapState, mapDispatch);

  const [curPetsInfo, setCurPetsInfo] = useState<PetsTokenList>({
    alignment: "",
    species: "",
    trait1: "",
    trait2: "",
    trait3: "",
  });

  const [curRoleInfo, setCurRoleInfo] = useState<RoleTokenList>({
    alignment: "",
    occupation: "",
    races: "",
    gender: "",
    trait1: "",
    trait2: "",
    trait3: "",
  });

  const [curLootInfo, setCurLootInfo] = useState<LootTokenList>({
    chest: "",
    foot: "",
    hand: "",
    head: "",
    neck: "",
    ring: "",
    waist: "",
    weapon: "",
  });

  const [curStep, setCurStep] = useState<number>(0);
  const [curBGUrl, setCurBGUrl] = useState<string | undefined>("");

  useEffect(() => {
    if (PetsContract && RoleContract && LootContract && MlootContract) {
      getRolesURI();
      getPetsURI();
      getLootsURI();
      getMlootsURI();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PetsContract, userInfo, RoleContract, LootContract, MlootContract]);

  return (
    <div className="role-plus">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={
          loading.effects.rolePlus.getLootsURI ||
          loading.effects.rolePlus.getMlootsURI ||
          loading.effects.rolePlus.getPetsURI ||
          loading.effects.rolePlus.getRolesURI
        }
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems="flexStart"
      >
        <Grid item xs={10} md={5} justifyContent="center">
          <div className="role-pic">
            <RolePlusSVG
              petsInfo={curPetsInfo}
              roleInfo={curRoleInfo}
              lootInfo={curLootInfo}
              bgUrl={curBGUrl}
            />
            {/* <div className="role-with-loot">
              <div className="left-loot">
                <div className="loot-item">sadkwodkowd</div>
                <div className="loot-item">sadkwodkowd</div>
                <div className="loot-item">sadkwodkowd</div>
                <div className="loot-item">sadkwodkowd</div>
              </div>
              <img src={HumanMale} width="100%" alt="" className="role-svg" />
              <div className="right-loot">
                <div className="loot-item">sadkwodkowd</div>
                <div className="loot-item">sadkwodkowd</div>
                <div className="loot-item">sadkwodkowd</div>
              </div>
            </div> */}
          </div>
        </Grid>
        <Grid
          container
          xs={10}
          md={7}
          flexDirection="column"
          justifyContent="flexStart"
          alignItems="flexStart"
        >
          <Box sx={{ width: "80%" }} style={{ margin: "0px 0px 24px 5%" }}>
            <Stepper activeStep={curStep}>
              {steps.map((label, index) => {
                const labelProps: {
                  optional?: React.ReactNode;
                  error?: boolean;
                } = {};
                // if (isStepFailed(index)) {
                //   labelProps.optional = (
                //     <Typography variant="caption" color="error">
                //       Alert message
                //     </Typography>
                //   );
                //   labelProps.error = true;
                // }

                return (
                  <Step key={label}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </Box>
          <div className="card-list">
            {curStep === 0 && (
              <Grid container spacing={2} alignItems="center">
                {RoleTokenList?.length === 0 ? (
                  <span
                    style={{
                      fontFamily:
                        '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                    }}
                  >
                    There is no Role in the wallet address.
                  </span>
                ) : (
                  RoleTokenList?.map((roleInfo, index) => {
                    return (
                      <Grid
                        item
                        xs={6}
                        md={4}
                        justifyContent="center"
                        key={index}
                        onClick={() => {
                          setCurRoleInfo(roleInfo);
                          setCurStep(1);
                        }}
                      >
                        <img
                          src={roleInfo!.URI!.image}
                          width="100%"
                          className="inner-svg"
                          alt=""
                        />
                      </Grid>
                    );
                  })
                )}
              </Grid>
            )}
            {curStep === 1 && (
              <Grid container spacing={2} alignItems="center">
                {LootTokenList?.length === 0 ? (
                  <span
                    style={{
                      fontFamily:
                        '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                    }}
                  >
                    There is no Loot or mLoot in the wallet address.
                  </span>
                ) : (
                  LootTokenList?.map((lootInfo, index) => {
                    return (
                      <Grid
                        item
                        xs={6}
                        md={4}
                        justifyContent="center"
                        key={index}
                        onClick={() => {
                          setCurLootInfo(lootInfo);
                          setCurStep(2);
                        }}
                      >
                        <img
                          src={lootInfo!.URI!.image}
                          width="100%"
                          className="inner-svg"
                          alt=""
                        />
                      </Grid>
                    );
                  })
                )}
              </Grid>
            )}
            {curStep === 2 && (
              <Grid container spacing={2} alignItems="center">
                {PetsTokenList?.length === 0 ? (
                  <span
                    style={{
                      fontFamily:
                        '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
                    }}
                  >
                    There is no Pets in the wallet address.
                  </span>
                ) : (
                  PetsTokenList?.map((petsInfo, index) => {
                    return (
                      <Grid
                        item
                        xs={6}
                        md={4}
                        justifyContent="center"
                        key={index}
                        onClick={() => {
                          setCurPetsInfo(petsInfo);
                          setCurStep(3);
                        }}
                      >
                        <img
                          src={petsInfo!.URI!.image}
                          width="100%"
                          className="inner-svg"
                          alt=""
                        />
                      </Grid>
                    );
                  })
                )}
              </Grid>
            )}
            {curStep === 3 && (
              <TextField
                id="standard-basic"
                label="Custom Background URL(Optional)"
                variant="standard"
                value={curBGUrl}
                onChange={(e) => {
                  setCurBGUrl(e.target.value);
                }}
                fullWidth
              />
            )}
          </div>
          <Grid
            container
            spacing={2}
            style={{ marginTop: "12px", marginLeft: "5%" }}
          >
            {(curStep === 1 || curStep === 2 || curStep === 3) && (
              <Grid item xs={5} md={5}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={() => {
                    setCurStep(curStep - 1);
                  }}
                >
                  Back
                </Button>
              </Grid>
            )}
            {(curStep === 0 || curStep === 1 || curStep === 2) && (
              <Grid item xs={5} md={5}>
                <Button
                  variant="contained"
                  fullWidth
                  disabled={RoleTokenList?.length === 0}
                  onClick={() => {
                    setCurStep(curStep + 1);
                  }}
                >
                  Next
                </Button>
              </Grid>
            )}
            {curStep === 3 && (
              <Grid item xs={5} md={5}>
                <Button
                  variant="contained"
                  fullWidth
                  disabled={
                    curLootInfo.id === undefined ||
                    curPetsInfo.id === undefined ||
                    curRoleInfo.id === undefined
                  }
                  onClick={() => {
                    console.log("curBGUrl", curBGUrl);
                    claimRolePlus({
                      lootId: Number(curLootInfo.id),
                      petId: Number(curPetsInfo.id),
                      roleId: Number(curRoleInfo.id),
                      imageUrl: curBGUrl || "",
                    });
                  }}
                >
                  Mint
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
